// @flow
import React from 'react'
import formatters from 'lib/formatters'
import Row from './Row'
import IconSwitch from 'components/IconSwitch/IconSwitch'
import Ref from 'components/References/Ref'

type Props = {
  hasSSI: boolean,
  hasSSIShelter: boolean,
  ssiAmount: number,
  ssiApprovalContentType: string,
}

const SSIRef = (props: Props) => {
  const {
    hasSSI,
    hasSSIShelter,
    ssiAmount,
  } = props

  let ssiDoc = 'No documentation'

  return (
    <Ref
      title="SSI"
      preview={
        <Row
          singleLine
          label="Supplemental Security Income"
          val={<IconSwitch flag={hasSSI} />}
        />
      }
      details={
        hasSSI && (
          <div>
            <Row
              singleLine
              label="Amount"
              val={formatters.money(ssiAmount || 0)}
              mono={true}
            />
            <Row
              singleLine
              label="Shelter"
              val={<IconSwitch flag={hasSSIShelter} />}
            />
          </div>
        )
      }
    />
  )
}

export default SSIRef
